import { useQuery } from "@tanstack/react-query";

import { listPendingAttendance } from "@/adapters/api";
import { usePermissions } from "@/hooks/use-permissions.ts";
import { useActiveContext } from "@/store/use-active-context";
import type { PendingAttendance } from "../types";
import { toPendingAttendance } from "../utils/map";

export function usePendingAttendance() {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);
	const { has } = usePermissions();
	const canListTeam = has("time_entries:list_team");

	return useQuery({
		queryKey: ["attendance", "pending", activeCanteiroId],
		enabled: canListTeam && activeCanteiroId != null,
		queryFn: async (): Promise<PendingAttendance> =>
			toPendingAttendance(
				await listPendingAttendance(activeCanteiroId as string),
			),
		staleTime: 60_000,
	});
}
